import { render, staticRenderFns } from "./SortingButtons.vue?vue&type=template&id=8bd16e40&"
import script from "./SortingButtons.vue?vue&type=script&lang=js&"
export * from "./SortingButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports